import React from 'react';
import { ContainerType } from '../types/container_type/containerType';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { instanceToPlain } from 'class-transformer';

export interface ContainerTypeContextProps {
  containerTypes: Map<string, ContainerType>;
  setContainerTypes: (containerTypes: Map<string, ContainerType>) => void;
  containerTypesLoading: boolean;
}

const defaultContext: ContainerTypeContextProps = {
  containerTypes: new Map(),
  setContainerTypes: () => {},
  containerTypesLoading: false,
};

export const ContainerTypeContext = React.createContext<ContainerTypeContextProps>(defaultContext);

interface ContainerTypeState {
  items: Record<string, any>[];
  loading: boolean;
}

export const containerTypeSlice = createSlice({
  name: 'containerType',
  initialState: { items: [], loading: true } as ContainerTypeState,
  reducers: {
    reset: state => {
      state.items = [];
      state.loading = true;
    },
    setAll: (state, action: PayloadAction<ContainerType[]>) => {
      state.items = action.payload.map(p => instanceToPlain(p));
    },
    addAll: (state, action: PayloadAction<ContainerType[]>) => {
      const map = new Map([...state.items, ...action.payload.map(p => instanceToPlain(p))].map(pmd => [pmd.id, pmd]));
      state.items = [...map.values()];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});
